"use strict";

exports.__esModule = true;
var _BarChartThumbnail = require("./BarChartThumbnail");
Object.keys(_BarChartThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BarChartThumbnail[key]) return;
  exports[key] = _BarChartThumbnail[key];
});